import React from "react";
import { Image, Popconfirm, Tag } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const CommonListCard = ({
  service,
  form,
  setEditingService,
  setEditing,
  handleDelete,
}: any) => {
  return (
    <div>
      <div key={service?._id} className="bg-[#F9F9F9] p-2 rounded-lg shadow">
        <div className="flex items-center gap-3">
          <Image
            src={service?.image}
            alt={service?.heading}
            width={60}
            className="rounded-md"
          />
          <div className="flex-1 space-y-1">
            <p className="font-semibold text-gray-900">{service?.heading}</p>
            <p className="text-gray-700 text-sm">Order: {service?.order}</p>
            <p className="text-gray-700 text-sm">
              <Tag color={service?.status ? "green" : "red"} bordered>
                {service?.status ? "Active" : "Inactive"}
              </Tag>
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-4 mt-3 text-primary">
          <EditOutlined
            className="cursor-pointer text-[20px]"
            onClick={() => {
              setEditingService(service);
              form.setFieldsValue({
                heading: service.heading,
                slug: service.slug,
                image: service.image ? [service.image] : [],
                status: service.status ?? false,
                order: Number(service.order) || 0,
              });
              setEditing(true);
            }}
          />
          <Popconfirm
            title="Are you sure to delete this service?"
            onConfirm={() => handleDelete(service?._id)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteOutlined className="cursor-pointer text-red-600 text-[20px]" />
          </Popconfirm>
        </div>
      </div>
    </div>
  );
};

export default CommonListCard;
